import PropTypes from 'prop-types'
//import { useSelector } from 'react-redux'

// material-ui
import { Typography } from '@mui/material'

// project import
import NavItem from './NavItem'
import NavCollapse from './NavCollapse'

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  //const actionName = 'menu'
  //const stateName = 'app_data'
  //const actionStateSelector = (state) => state[stateName][actionName]
  //const itemRes = useSelector(actionStateSelector)
  //const drawerOpen = itemRes?.data?.drawerOpen ?? false

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        )
    }
  })
  return navCollapse
  /*
  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  )
  */
}

NavGroup.propTypes = {
  item: PropTypes.object
}

export default NavGroup
